import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const StarIcon = ({
  color = 'white',
  width = 12,
  marginLeft,
  marginRight,
  containerSize,
  variant,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    {variant === 'fill' ? (
      <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask
          id="mask0_3132_35594"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="22"
          height="22"
        >
          <path
            d="M10.1032 1.81696C10.47 1.07371 11.5298 1.07371 11.8967 1.81696L14.294 6.67443C14.4396 6.96957 14.7212 7.17414 15.0469 7.22147L20.4074 8.0004C21.2276 8.11958 21.5552 9.12755 20.9616 9.70609L17.0827 13.4871C16.847 13.7168 16.7395 14.0478 16.7951 14.3722L17.7108 19.7111C17.8509 20.528 16.9935 21.151 16.2599 20.7653L11.4653 18.2446C11.1739 18.0915 10.8259 18.0915 10.5346 18.2446L5.73997 20.7653C5.00634 21.151 4.14891 20.528 4.28902 19.7111L5.2047 14.3722C5.26034 14.0478 5.15279 13.7168 4.91711 13.4871L1.03819 9.70609C0.444672 9.12756 0.772181 8.11958 1.5924 8.0004L6.95294 7.22147C7.27865 7.17414 7.56021 6.96957 7.70588 6.67443L10.1032 1.81696Z"
            fill={getSemanticTextColor(color)}
          />
        </mask>
        <g mask="url(#mask0_3132_35594)">
          <rect width="22" height="22" fill={getSemanticTextColor(color)} />
        </g>
      </svg>
    ) : (
      <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask
          id="mask0_3132_34406"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="22"
          height="22"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.9999 3.61525L9.14065 7.38253C8.76193 8.1499 8.02986 8.68178 7.18301 8.80484L3.02558 9.40895L6.03393 12.3414C6.64671 12.9387 6.92634 13.7993 6.78168 14.6427L6.0715 18.7833L9.79003 16.8284C10.5475 16.4302 11.4524 16.4302 12.2098 16.8284L15.9283 18.7833L15.2182 14.6427C15.0735 13.7993 15.3531 12.9387 15.9659 12.3414L18.9743 9.40895L14.8168 8.80484C13.97 8.68178 13.2379 8.1499 12.8592 7.38253L10.9999 3.61525ZM11.8967 1.81696C11.5298 1.07371 10.47 1.07371 10.1032 1.81696L7.70588 6.67443C7.56021 6.96957 7.27865 7.17414 6.95294 7.22147L1.5924 8.0004C0.772181 8.11958 0.444672 9.12756 1.03819 9.70609L4.91711 13.4871C5.15279 13.7168 5.26034 14.0478 5.2047 14.3722L4.28902 19.7111C4.14891 20.528 5.00634 21.151 5.73997 20.7653L10.5346 18.2446C10.8259 18.0915 11.1739 18.0915 11.4653 18.2446L16.2599 20.7653C16.9935 21.151 17.8509 20.528 17.7108 19.7111L16.7951 14.3722C16.7395 14.0478 16.847 13.7168 17.0827 13.4871L20.9616 9.70609C21.5552 9.12755 21.2276 8.11958 20.4074 8.0004L15.0469 7.22147C14.7212 7.17414 14.4396 6.96957 14.294 6.67443L11.8967 1.81696Z"
            fill="#1D1D1B"
          />
        </mask>
        <g mask="url(#mask0_3132_34406)">
          <rect width="22" height="22" fill={getSemanticTextColor(color)} />
        </g>
      </svg>
    )}
  </DefaultIconWrapper>
);
